import { Link } from '@/components/LocalizedLink';
import type { SolutionDefinition } from '@/lib/solutionCatalog';
import { localizeSolutionText } from '@/lib/solutionCatalog';
import { useLanguage } from '@/contexts/LanguageContext';

type RelatedSolutionsBlockProps = {
  solutions: SolutionDefinition[];
  title?: string;
};

const RelatedSolutionsBlock = ({ solutions, title }: RelatedSolutionsBlockProps) => {
  const { lang } = useLanguage();

  if (!solutions.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="font-display text-3xl font-bold text-foreground mb-6">
        {title || (lang === 'tr' ? 'İlgili Çözüm Sayfaları' : 'Related Solution Pages')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {solutions.map((solution) => (
          <Link
            key={solution.slug}
            to={`/solutions/${solution.slug}`}
            className="rounded-xl border border-border/70 p-5 bg-card/40 hover:bg-card transition-colors"
          >
            <p className="font-display text-xl text-foreground mb-2">
              {localizeSolutionText(solution.title, lang)}
            </p>
            <p className="font-body text-sm text-muted-foreground leading-relaxed">
              {localizeSolutionText(solution.intro, lang)}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedSolutionsBlock;
